/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_Notes_Surround_SingleInputs */



/**
* | output |
* | --- |
* | "Surround Single (♪... ♪)" |
*
* @param {Music_Notes_Surround_SingleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes_surround_single = /** @type {((inputs?: Music_Notes_Surround_SingleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_Notes_Surround_SingleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encadrer simple (♪... ♪)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Surround Single (♪... ♪)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Surround Singolo (♪... ♪)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объемный звук (♪... ♪)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sonido envolvente sencillo (♪... ♪)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("环绕单曲（♪... ♪）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サラウンドシングル（♪…♪）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सराउंड सिंगल (♪... ♪)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Surround Single (♪... ♪)")
	return /** @type {LocalizedString} */ ("Surround Single (♪... ♪)")
});